<template>
    <div id="incentiveManagement" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>奖励管理</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="奖励日期" prop="dateRange" label-width="100px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="购买快递单号" prop="couriernumber" label-width="100px">
                    <el-input v-model="queryParams.couriernumber" clearable placeholder="购买快递单号" size="small" />
                </el-form-item>

                <el-form-item label="转寄快递单号" prop="forwardtrackingnumber" label-width="100px">
                    <el-input v-model="queryParams.forwardtrackingnumber" clearable placeholder="转寄快递单号" size="small" />
                </el-form-item>

                <el-form-item label="是否核销" prop="verifystatus" label-width="100px">
                    <el-select v-model="queryParams.verifystatus" clearable placeholder="是否核销" size="small">
                        <el-option v-for="item in forwardstatusLIst" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="指派人" prop="dealername" label-width="100px" v-if="logintype == 'HCM'">
                    <el-select v-model="queryParams.dealername" clearable placeholder="指派人" size="small">
                        <el-option v-for="item in appointorList" :key="item.dealername" :label="item.dealername"
                            :value="item.dealername">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <!-- <el-col :span="1.5">
                    <el-button size="mini" @click="allHandleAdd" v-if="logintype != 'HCM'">批量奖励</el-button>
                </el-col> -->
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
            </el-row>
            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun" ref="multipleTable">
                <el-table-column label="是否核销" align="left" key="verifystatus" prop="verifystatus" />
                <el-table-column label="指派人" align="left" key="dealername" prop="dealername" />
                <el-table-column label="购买数量" align="left" key="paynum" prop="paynum" />
                <el-table-column label="支付金额" align="left" key="payprice" prop="payprice" />
                <el-table-column label="原箱编码" align="left" key="encoding" prop="encoding" />
                <el-table-column label="购买快递单号" align="left" key="couriernumber" prop="couriernumber" />
                <el-table-column label="转寄快递单号" align="left" key="forwardtrackingnumber" prop="forwardtrackingnumber" />
                <el-table-column label="奖励金额" align="left" key="rewardsprice" prop="rewardsprice" />
                <el-table-column label="奖励日期" align="left" key="rewardsdate" prop="rewardsdate" />
                <el-table-column label="实收数量" align="left" key="quantitycollected" prop="quantitycollected" />
                <el-table-column label="收货说明" align="left" key="quantityexplain" prop="quantityexplain" />
                <el-table-column label="可核销金额" align="left" key="verifyprice" prop="verifyprice" />
                <el-table-column label="可核销奖励" align="left" key="verifyrewardsprice" prop="verifyrewardsprice" />

                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
                <el-table-column label="操作" align="left" width="100" v-if="logintype === 'HCM'">
                    <template slot-scope="scope">
                        <!-- :disabled="scope.row.verifystatus == '已核销'" -->
                        <el-button size="mini" type="text" @click.stop="handleUpdate(scope.row)"
                            >核销</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <!-- 批量任务 -->
        <el-dialog title="批量任务" class="importModal" :visible.sync="BulkImportShow" :close-on-click-modal="false"
            width="640px" id="dialog">
            <div class="wrap" style="margin: 10px;">
                <el-upload ref="newupload" class="upload-demo" drag
                    action="hcm/hcmOrderrewards/hcmOrderForwardbmcDownload" :auto-upload="false" multiple
                    :before-upload="beforeUpload" accept=".xls,.xlsx" :on-success="confirmUpload">
                    <i class="el-icon-upload" style="color: #BDA571;"></i>
                    <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
                        <br>
                        <span style="font-size: 14px;color: #d4d4d4;">
                            支持扩展名：.xls .xlsx
                        </span>
                    </div>
                    <!-- <el-button type="text" @click="download">下载导入模板</el-button> -->
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
                <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取
                    消</el-button>
            </div>
        </el-dialog>
        <!-- 导入结果说明 -->
        <el-dialog title="导入结果说明" :visible.sync="responseShow" :close-on-click-modal="false" width="960px" id="dialog">
            <div style="height: 574px;overflow: auto;">
                <div class="prompt"
                    style="margin-top: 5px;margin-bottom: 8px;width: calc(100% - 40px);margin-left: 20px;margin-right: 20px;">
                    <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
                    <span class="promptFont">{{ modalInfo.message }}</span>
                </div>
                <el-table :data="responseData" style="width: 100%">
                    <el-table-column prop="dealername" label="指派人" />
                    <el-table-column prop="verifystatus" label="是否转寄" />
                    <el-table-column prop="payuser" label="购买人" />
                    <el-table-column prop="specification" label="规格" />
                    <el-table-column prop="controlstandard" label="管控标准" />
                    <el-table-column prop="productlink" label="购买链接" />
                    <el-table-column prop="completedate" label="要求购买完成日期">
                        <template slot-scope="scope">
                            {{ scope.row.productlink | fullTime }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="purchaserequirement" label="购买要求" />
                    <el-table-column prop="stopbuyingrequest" label="停止购买要求" />
                    <el-table-column label="错误说明" fixed="right" width="200">
                        <template slot-scope="scope">
                            <span style="color: red;">
                                {{ scope.row.err_info }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="responseShow = false" size="small">确
                    定</el-button>
            </div>
        </el-dialog>
        <!-- 奖励详情 -->
        <el-dialog :title="title" :visible.sync="open" width="720px" append-to-body>
            <el-form ref="form" :model="form" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="是否核销">
                            <span v-if="form.verifystatus == '1'">
                                已核销
                            </span>
                            <span v-else>
                                未核销
                            </span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="指派人">
                            {{ form.dealername }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="购买数量">
                            {{ form.paynum }}
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="24">
                        <el-form-item label="支付金额">
                            {{ form.payprice }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="原箱编码">
                            {{ form.encoding }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="购买快递单号">
                            {{ form.couriernumber }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="转寄快递单号">
                            {{ form.forwardtrackingnumber }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="奖励金额">
                            {{ form.rewardsprice }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="奖励日期" prop="rewardsdate">
                            <el-date-picker v-model="form.rewardsdate" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择确认日期" style="width: 410px;" size="small"
                                :disabled="logintype != 'HCM'"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="实收数量">
                            {{ form.quantitycollected }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="收货说明">
                            {{ form.quantityexplain }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="可核销金额">
                            {{ form.verifyprice }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="可核销奖励">
                            {{ form.verifyrewardsprice }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '奖励详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '奖励详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '奖励详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '奖励详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm" v-if="logintype == 'HCM'">确 定</el-button>
                <el-button @click="open = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 核销 -->
        <el-dialog title="核销" :visible.sync="hexiaoShow" width="600px" append-to-body>
            <el-form ref="hexiaoData" :model="hexiaoData" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="指派人">
                            {{ hexiaoData.dealername }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="购买数量">
                            {{ hexiaoData.paynum }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="原箱编码">
                            {{ hexiaoData.encoding }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="实收数量" required>
                            <el-input v-model="hexiaoData.quantitycollected" clearable placeholder="购买快递单号"
                                size="small" type="number"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm2">确 定</el-button>
                <el-button @click="hexiaoShow = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
export default {
    name: "incentiveManagement",
    data() {
        return {
            hexiaoData: {},
            bigOpen: false,
            bigurl: '',
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                couriernumber: null,
                forwardtrackingnumber: null,
                dealername: null,
                verifystatus: null,
            },
            totalNum: 0,
            openNumber: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            forwardstatusLIst: [{
                label: '已核销',
                value: '1'
            }, {
                label: '未核销',
                value: '0'
            }],
            appointorList: [],
            logintype: '',
            bulLoading: false,
            BulkImportShow: false,
            responseShow: false,
            responseData: [],
            modalInfo: {},
            title: '',
            open: false,
            form: {},
            hexiaoShow: false,
        };
    },
    components: {
        pagination
    },
    created() {
        this.getList();
        this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
        this.getOrderTaskBmcDealerName();
    },
    methods: {
        submitForm2() {
            if (this.hexiaoData.quantitycollected < 0) {
                this.$message.warning('数量不能小于0');
                return;
            }
            if (this.hexiaoData.quantitycollected > this.hexiaoData.paynum) {
                this.$message.warning('超出购买数量');
                return;
            }
            let params = {
                id: this.hexiaoData.id,
                quantitycollected: this.hexiaoData.quantitycollected
            }
            fetch({
                url: "hcm/hcmOrderrewards/savequantitycollected",
                method: "post",
                data: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let data = JSON.parse(res);
                if (data.status === '10000') {
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    })
                    this.getList();
                    this.hexiaoShow = false;
                } else {
                    this.$message.error(data.message);
                }
            }).catch(err => {
                this.$message.error('服务器出错');
            });
        },
        handleUpdate(data) {
            this.hexiaoData = data;
            this.hexiaoShow = true;
        },
        // 提交
        submitForm() {
            let data = [this.form]
            fetch({
                url: "hcm/hcmOrderrewards/saveOrderrewards",
                method: "post",
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                },
                noFormat: false,
                responseType: "json"
            }).then((res) => {
                if (res.status === '10000') {
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    })
                    this.open = false;
                } else {
                    this.$message.error(res.message);
                }
            }).catch(err => {
                this.$message.error('服务器出错');
            });
        },
        download() {
            window.open("https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E6%89%B9%E9%87%8F%E4%BB%BB%E5%8A%A1%E6%A8%A1%E6%9D%BF%EF%BC%88%E5%93%81%E7%89%8C%E6%96%B9%EF%BC%89.xlsx");
        },
        // 确定导入
        BulkImport() {
            this.bulLoading = true
            this.$refs.newupload.submit();
        },
        // 取消导入
        BulkImportShowf() {
            this.BulkImportShow = false
            this.$refs.newupload.clearFiles();
        },
        beforeUpload(file) {
            let Xls = file.name
            if (Xls.search("xls") != -1 || Xls.search("xlsx") != -1) {
                return file
            } else {
                this.$message.error('上传文件只能是 xls/xlsx 格式!')
                this.bulLoading = false
                return false
            }
        },
        confirmUpload(response) {
            if (response.status == 10000) {
                if (response.data && response.data.length > 0) {
                    this.$message({
                        message: response.message,
                        type: 'warning'
                    });
                    this.responseShow = true
                    this.responseData = response.data
                    this.modalInfo = response
                } else {
                    this.$message({
                        message: response.message,
                        type: 'success'
                    });
                    this.BulkImportShow = false
                }
                this.bulLoading = false
                this.$refs.newupload.clearFiles();
                this.getList();
            } else {
                this.bulLoading = false
                this.getList();
                this.BulkImportShow = false
                this.$message.error(response.message);
                this.$refs.newupload.clearFiles();
            }
        },
        getOrderTaskBmcDealerName() {
            fetch({
                url: "hcm/hcmOrdertaskbmc/getOrderTaskBmcDealerName",
                method: "get",
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.appointorList = [];
                    this.appointorList = result.data;
                }
            })
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        // hcm详情
        taskidFun(data) {
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrderrewards/getOrderrewardsDetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.form = result.data.details;
                    this.form.rewardsdate = this.$options.filters.fullTime(this.form.rewardsdate);
                    this.title = '奖励详情';
                    this.open = true;
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrderrewards/getList",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrderrewards/hcmOrderrewardsDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '奖励管理.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 批量转寄
        allHandleAdd() {
            this.BulkImportShow = true
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
    }
};
</script>
<style lang="scss">
.prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 8px;
}

.promptFont {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
}

.promptFont2 {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
}

.el-table th {
    background-color: #f3f7ff !important;
}

.el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
}
</style>